/**
 * Shared constants and ID helpers for the trip planning pipeline.
 *
 * These values are referenced across route inference, DAG construction, LP
 * model building, trailer-cargo bans, supply flow, packing task generation,
 * and fingerprinting. Use these exports instead of hardcoding strings.
 */

/**
 * Exact category name used to identify trailer item types throughout routing
 * and LP logic. Any item type whose category.name equals this string is treated
 * as a trailer — it defines which events a trailer visits and drives route
 * inference. Renaming this category in the database requires updating it here.
 */
export const TRAILER_CATEGORY_NAME = 'Trailers' as const;
export type TrailerCategoryName = typeof TRAILER_CATEGORY_NAME;

/**
 * DAG node ID for a source storage location.
 * Distinct from dagDestNodeId so that trips where source === dest storage do
 * not produce a cycle in the graph.
 */
export function dagSourceNodeId(storageLocationId: string): string {
    return `storage:source:${storageLocationId}`;
}

/**
 * DAG node ID for a destination storage location.
 * Distinct from dagSourceNodeId for the same reason.
 */
export function dagDestNodeId(storageLocationId: string): string {
    return `storage:dest:${storageLocationId}`;
}
